"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _classCallCheck2 = require("babel-runtime/helpers/classCallCheck");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require("babel-runtime/helpers/createClass");

var _createClass3 = _interopRequireDefault(_createClass2);

var _ErrorApi = require("./../../../../utils/ErrorApi");

var _ErrorApi2 = _interopRequireDefault(_ErrorApi);

var _Fetch = require("./../../../../utils/Fetch");

var _Fetch2 = _interopRequireDefault(_Fetch);

var _ParamsFetch = require("./../../../../utils/ParamsFetch");

var _ParamsFetch2 = _interopRequireDefault(_ParamsFetch);

var _JsonFetch = require("./../../../../utils/JsonFetch");

var _JsonFetch2 = _interopRequireDefault(_JsonFetch);

var _generateUrl = require("./../../../../utils/generateUrl");

var _generateUrl2 = _interopRequireDefault(_generateUrl);

var _UpdateMethods = require("./../UpdateMethods");

var UpdateMethods = _interopRequireWildcard(_UpdateMethods);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Service pro tisk štítků a obálek. Generated from cz.marbes.api.dokument.v1.obalky.ObalkaService.
 */
// ##############################################################

// #             GENEROVANÝ KÓD, NEMODIFIKOVAT!!!!              #

// #                  2024-05-22T17:57:19Z                      #

// ##############################################################

var ObalkaApi = function () {
  function ObalkaApi() {
    (0, _classCallCheck3.default)(this, ObalkaApi);
  }

  (0, _createClass3.default)(ObalkaApi, null, [{
    key: "tiskTestovaciStranky",

    /**
     * Vrací testovací stránku.
     *
     * @param pageOffset posun tisku
     * @return testovací stránka
     */
    value: function tiskTestovaciStranky(pageOffset) {
      var uri = serverContextPath + "/api/dokumenty/v1/obalky/testovaci/stranka/stream";
      var params = {};
      return (0, _generateUrl2.default)(uri, params, true);
    }

    /**
     * 
     *
     * @param sablonaKod jednoznačný identifikátor použité šablony
     * @return instance vyplněná dle zvolené šablony
     */

  }, {
    key: "createTiskAdresMetaDefault",
    value: function createTiskAdresMetaDefault(sablonaKod) {
      var uri = serverContextPath + ("/api/dokumenty/v1/obalky/sablona/" + sablonaKod + "/create");
      var headers = undefined;
      var params = {};

      return _ErrorApi2.default.responseResolver(_JsonFetch2.default.post(uri, params, 0, headers));
    }

    /**
     * Vrácí seznam nakonfigurovaných adresních štítků.
     *
     * @return seznam adresních štítků
     */

  }, {
    key: "getSablony",
    value: function getSablony() {
      var uri = serverContextPath + "/api/dokumenty/v1/obalky/sablony";
      var headers = undefined;
      var params = {};

      return _ErrorApi2.default.responseResolver(_JsonFetch2.default.get(uri, params, headers));
    }

    /**
     * Vytiskne adresní údaje podle zadaných metadat a položek.
     *
     * @param sablonaKod jednoznačný identifikátor použité šablony
     * @param stitky štítky, které budeme tisknout
     * @param odesilatel id subjektu odesílatele - odesílatel pro tisk na obálku, při null bude odesílatel nevyplněn
     * @param meta další vlastnosti pro tisk obálek, doplňující a řídící údaje tisku, pokud bude předán {@code null} budou použity prázdné hodnoty
     * @param pageOffset nastavení posunu stránky (vyrovnání chyby podavače), při null bude posun 0 v obou směrech
     * @return Renderované štítky ve formátu PDF
     */

  }, {
    key: "tisk",
    value: function tisk(sablonaKod, stitky, odesilatel, meta, pageOffset) {
      var uri = serverContextPath + ("/api/dokumenty/v1/obalky/sablona/" + sablonaKod + "/stream");
      var params = { odesilatel: odesilatel, meta: meta, pageOffset: pageOffset };
      return (0, _generateUrl2.default)(uri, params, true);
    }

    /**
     * Najde konkrétní šablonu dle kódu.
     *
     * @param sablonaKod kód šablony
     * @return šablona
     */

  }, {
    key: "getObalkaSablonaByKod",
    value: function getObalkaSablonaByKod(sablonaKod) {
      var uri = serverContextPath + ("/api/dokumenty/v1/obalky/sablona/" + sablonaKod);
      var headers = undefined;
      var params = {};

      return _ErrorApi2.default.responseResolver(_JsonFetch2.default.get(uri, params, headers));
    }

    /**
     * Vytiskne testovací štítek s umělými daty.
     *
     * @param sablonaKod kód šablony
     * @param pageOffset posun tisku
     * @return testovací štítek
     */

  }, {
    key: "zkusebniTisk",
    value: function zkusebniTisk(sablonaKod, pageOffset) {
      var uri = serverContextPath + ("/api/dokumenty/v1/obalky/testovaci/sablona/" + sablonaKod + "/stream");
      var params = { pageOffset: pageOffset };
      return (0, _generateUrl2.default)(uri, params, true);
    }
  }]);
  return ObalkaApi;
}();

exports.default = ObalkaApi;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uLy4uLy4uLy4uL3NyYy9saWIvYXBpL2dlbi9vYmFsa3kvdjEvT2JhbGthQXBpLmpzeCJdLCJuYW1lcyI6WyJVcGRhdGVNZXRob2RzIiwiT2JhbGthQXBpIiwicGFnZU9mZnNldCIsInVyaSIsInNlcnZlckNvbnRleHRQYXRoIiwicGFyYW1zIiwic2FibG9uYUtvZCIsImhlYWRlcnMiLCJ1bmRlZmluZWQiLCJFcnJvckFwaSIsInJlc3BvbnNlUmVzb2x2ZXIiLCJKc29uRmV0Y2giLCJwb3N0IiwiZ2V0Iiwic3RpdGt5Iiwib2Rlc2lsYXRlbCIsIm1ldGEiXSwibWFwcGluZ3MiOiI7Ozs7Ozs7Ozs7Ozs7O0FBUUE7Ozs7QUFDQTs7OztBQUNBOzs7O0FBQ0E7Ozs7QUFDQTs7OztBQUVBOztJQUFZQSxhOzs7Ozs7QUFFWjs7O0FBaEJBOztBQUVBOztBQUVBOztBQUVBOztJQWFxQkMsUzs7Ozs7Ozs7QUFDakI7Ozs7Ozt5Q0FNNEJDLFUsRUFBcUI7QUFDN0MsVUFBTUMsTUFBTUMsdUVBQVo7QUFDQSxVQUFNQyxTQUFTLEVBQWY7QUFDQSxhQUFPLDJCQUFZRixHQUFaLEVBQWlCRSxNQUFqQixFQUF5QixJQUF6QixDQUFQO0FBQ0g7O0FBRUQ7Ozs7Ozs7OzsrQ0FNa0NDLFUsRUFBWTtBQUMxQyxVQUFNSCxNQUFNQywyREFBd0RFLFVBQXhELGFBQVo7QUFDQSxVQUFNQyxVQUFVQyxTQUFoQjtBQUNBLFVBQU1ILFNBQVMsRUFBZjs7QUFFQSxhQUFPSSxtQkFBU0MsZ0JBQVQsQ0FBMEJDLG9CQUFVQyxJQUFWLENBQWVULEdBQWYsRUFBb0JFLE1BQXBCLEVBQTRCLENBQTVCLEVBQStCRSxPQUEvQixDQUExQixDQUFQO0FBQ0g7O0FBRUQ7Ozs7Ozs7O2lDQUtvQjtBQUNoQixVQUFNSixNQUFNQyxzREFBWjtBQUNBLFVBQU1HLFVBQVVDLFNBQWhCO0FBQ0EsVUFBTUgsU0FBUyxFQUFmOztBQUVBLGFBQU9JLG1CQUFTQyxnQkFBVCxDQUEwQkMsb0JBQVVFLEdBQVYsQ0FBY1YsR0FBZCxFQUFtQkUsTUFBbkIsRUFBMkJFLE9BQTNCLENBQTFCLENBQVA7QUFDSDs7QUFFRDs7Ozs7Ozs7Ozs7Ozt5QkFVWUQsVSxFQUFZUSxNLEVBQVFDLFUsRUFBWUMsSSxFQUFNZCxVLEVBQXFCO0FBQ25FLFVBQU1DLE1BQU1DLDJEQUF3REUsVUFBeEQsYUFBWjtBQUNBLFVBQU1ELFNBQVMsRUFBRVUsc0JBQUYsRUFBY0MsVUFBZCxFQUFvQmQsc0JBQXBCLEVBQWY7QUFDQSxhQUFPLDJCQUFZQyxHQUFaLEVBQWlCRSxNQUFqQixFQUF5QixJQUF6QixDQUFQO0FBQ0g7O0FBRUQ7Ozs7Ozs7OzswQ0FNNkJDLFUsRUFBWTtBQUNyQyxVQUFNSCxNQUFNQywyREFBd0RFLFVBQXhELENBQVo7QUFDQSxVQUFNQyxVQUFVQyxTQUFoQjtBQUNBLFVBQU1ILFNBQVMsRUFBZjs7QUFFQSxhQUFPSSxtQkFBU0MsZ0JBQVQsQ0FBMEJDLG9CQUFVRSxHQUFWLENBQWNWLEdBQWQsRUFBbUJFLE1BQW5CLEVBQTJCRSxPQUEzQixDQUExQixDQUFQO0FBQ0g7O0FBRUQ7Ozs7Ozs7Ozs7aUNBT29CRCxVLEVBQVlKLFUsRUFBcUI7QUFDakQsVUFBTUMsTUFBTUMscUVBQWtFRSxVQUFsRSxhQUFaO0FBQ0EsVUFBTUQsU0FBUyxFQUFFSCxzQkFBRixFQUFmO0FBQ0EsYUFBTywyQkFBWUMsR0FBWixFQUFpQkUsTUFBakIsRUFBeUIsSUFBekIsQ0FBUDtBQUNIOzs7OztrQkFqRmdCSixTIiwiZmlsZSI6Ik9iYWxrYUFwaS5qcyIsInNvdXJjZXNDb250ZW50IjpbIi8vICMjIyMjIyMjIyMjIyMjIyMjIyMjIyMjIyMjIyMjIyMjIyMjIyMjIyMjIyMjIyMjIyMjIyMjIyMjIyMjIyMjXG5cbi8vICMgICAgICAgICAgICAgR0VORVJPVkFOw50gS8OTRCwgTkVNT0RJRklLT1ZBVCEhISEgICAgICAgICAgICAgICNcblxuLy8gIyAgICAgICAgICAgICAgICAgIDIwMjQtMDUtMjJUMTc6NTc6MTlaICAgICAgICAgICAgICAgICAgICAgICNcblxuLy8gIyMjIyMjIyMjIyMjIyMjIyMjIyMjIyMjIyMjIyMjIyMjIyMjIyMjIyMjIyMjIyMjIyMjIyMjIyMjIyMjIyNcblxuaW1wb3J0IEVycm9yQXBpIGZyb20gXCIuLy4uLy4uLy4uLy4uL3V0aWxzL0Vycm9yQXBpXCI7XG5pbXBvcnQgRmV0Y2ggZnJvbSBcIi4vLi4vLi4vLi4vLi4vdXRpbHMvRmV0Y2hcIjtcbmltcG9ydCBQYXJhbXNGZXRjaCBmcm9tIFwiLi8uLi8uLi8uLi8uLi91dGlscy9QYXJhbXNGZXRjaFwiO1xuaW1wb3J0IEpzb25GZXRjaCBmcm9tIFwiLi8uLi8uLi8uLi8uLi91dGlscy9Kc29uRmV0Y2hcIjtcbmltcG9ydCBnZW5lcmF0ZVVybCBmcm9tICcuLy4uLy4uLy4uLy4uL3V0aWxzL2dlbmVyYXRlVXJsJztcblxuaW1wb3J0ICogYXMgVXBkYXRlTWV0aG9kcyBmcm9tIFwiLi8uLi9VcGRhdGVNZXRob2RzXCI7XG5cbi8qKlxuICogU2VydmljZSBwcm8gdGlzayDFoXTDrXRrxa8gYSBvYsOhbGVrLiBHZW5lcmF0ZWQgZnJvbSBjei5tYXJiZXMuYXBpLmRva3VtZW50LnYxLm9iYWxreS5PYmFsa2FTZXJ2aWNlLlxuICovXG5leHBvcnQgZGVmYXVsdCBjbGFzcyBPYmFsa2FBcGkge1xuICAgIC8qKlxuICAgICAqIFZyYWPDrSB0ZXN0b3ZhY8OtIHN0csOhbmt1LlxuICAgICAqXG4gICAgICogQHBhcmFtIHBhZ2VPZmZzZXQgcG9zdW4gdGlza3VcbiAgICAgKiBAcmV0dXJuIHRlc3RvdmFjw60gc3Ryw6Fua2FcbiAgICAgKi9cbiAgICBzdGF0aWMgdGlza1Rlc3RvdmFjaVN0cmFua3kocGFnZU9mZnNldCkgOiBTdHJpbmcge1xuICAgICAgICBjb25zdCB1cmkgPSBzZXJ2ZXJDb250ZXh0UGF0aCArIGAvYXBpL2Rva3VtZW50eS92MS9vYmFsa3kvdGVzdG92YWNpL3N0cmFua2Evc3RyZWFtYDtcbiAgICAgICAgY29uc3QgcGFyYW1zID0geyAgfTtcbiAgICAgICAgcmV0dXJuIGdlbmVyYXRlVXJsKHVyaSwgcGFyYW1zLCB0cnVlKTtcbiAgICB9XG5cbiAgICAvKipcbiAgICAgKiBcbiAgICAgKlxuICAgICAqIEBwYXJhbSBzYWJsb25hS29kIGplZG5vem5hxI1uw70gaWRlbnRpZmlrw6F0b3IgcG91xb5pdMOpIMWhYWJsb255XG4gICAgICogQHJldHVybiBpbnN0YW5jZSB2eXBsbsSbbsOhIGRsZSB6dm9sZW7DqSDFoWFibG9ueVxuICAgICAqL1xuICAgIHN0YXRpYyBjcmVhdGVUaXNrQWRyZXNNZXRhRGVmYXVsdChzYWJsb25hS29kKSB7XG4gICAgICAgIGNvbnN0IHVyaSA9IHNlcnZlckNvbnRleHRQYXRoICsgYC9hcGkvZG9rdW1lbnR5L3YxL29iYWxreS9zYWJsb25hLyR7c2FibG9uYUtvZH0vY3JlYXRlYDtcbiAgICAgICAgY29uc3QgaGVhZGVycyA9IHVuZGVmaW5lZDtcbiAgICAgICAgY29uc3QgcGFyYW1zID0geyAgfTtcbiAgICAgICAgIFxuICAgICAgICByZXR1cm4gRXJyb3JBcGkucmVzcG9uc2VSZXNvbHZlcihKc29uRmV0Y2gucG9zdCh1cmksIHBhcmFtcywgMCwgaGVhZGVycykpO1xuICAgIH1cblxuICAgIC8qKlxuICAgICAqIFZyw6Fjw60gc2V6bmFtIG5ha29uZmlndXJvdmFuw71jaCBhZHJlc27DrWNoIMWhdMOtdGvFry5cbiAgICAgKlxuICAgICAqIEByZXR1cm4gc2V6bmFtIGFkcmVzbsOtY2ggxaF0w610a8WvXG4gICAgICovXG4gICAgc3RhdGljIGdldFNhYmxvbnkoKSB7XG4gICAgICAgIGNvbnN0IHVyaSA9IHNlcnZlckNvbnRleHRQYXRoICsgYC9hcGkvZG9rdW1lbnR5L3YxL29iYWxreS9zYWJsb255YDtcbiAgICAgICAgY29uc3QgaGVhZGVycyA9IHVuZGVmaW5lZDtcbiAgICAgICAgY29uc3QgcGFyYW1zID0geyAgfTtcbiAgICAgICAgIFxuICAgICAgICByZXR1cm4gRXJyb3JBcGkucmVzcG9uc2VSZXNvbHZlcihKc29uRmV0Y2guZ2V0KHVyaSwgcGFyYW1zLCBoZWFkZXJzKSk7XG4gICAgfVxuXG4gICAgLyoqXG4gICAgICogVnl0aXNrbmUgYWRyZXNuw60gw7pkYWplIHBvZGxlIHphZGFuw71jaCBtZXRhZGF0IGEgcG9sb8W+ZWsuXG4gICAgICpcbiAgICAgKiBAcGFyYW0gc2FibG9uYUtvZCBqZWRub3puYcSNbsO9IGlkZW50aWZpa8OhdG9yIHBvdcW+aXTDqSDFoWFibG9ueVxuICAgICAqIEBwYXJhbSBzdGl0a3kgxaF0w610a3ksIGt0ZXLDqSBidWRlbWUgdGlza25vdXRcbiAgICAgKiBAcGFyYW0gb2Rlc2lsYXRlbCBpZCBzdWJqZWt0dSBvZGVzw61sYXRlbGUgLSBvZGVzw61sYXRlbCBwcm8gdGlzayBuYSBvYsOhbGt1LCBwxZlpIG51bGwgYnVkZSBvZGVzw61sYXRlbCBuZXZ5cGxuxJtuXG4gICAgICogQHBhcmFtIG1ldGEgZGFsxaHDrSB2bGFzdG5vc3RpIHBybyB0aXNrIG9iw6FsZWssIGRvcGzFiHVqw61jw60gYSDFmcOtZMOtY8OtIMO6ZGFqZSB0aXNrdSwgcG9rdWQgYnVkZSBwxZllZMOhbiB7QGNvZGUgbnVsbH0gYnVkb3UgcG91xb5pdHkgcHLDoXpkbsOpIGhvZG5vdHlcbiAgICAgKiBAcGFyYW0gcGFnZU9mZnNldCBuYXN0YXZlbsOtIHBvc3VudSBzdHLDoW5reSAodnlyb3Zuw6Fuw60gY2h5YnkgcG9kYXZhxI1lKSwgcMWZaSBudWxsIGJ1ZGUgcG9zdW4gMCB2IG9ib3Ugc23Em3JlY2hcbiAgICAgKiBAcmV0dXJuIFJlbmRlcm92YW7DqSDFoXTDrXRreSB2ZSBmb3Jtw6F0dSBQREZcbiAgICAgKi9cbiAgICBzdGF0aWMgdGlzayhzYWJsb25hS29kLCBzdGl0a3ksIG9kZXNpbGF0ZWwsIG1ldGEsIHBhZ2VPZmZzZXQpIDogU3RyaW5nIHtcbiAgICAgICAgY29uc3QgdXJpID0gc2VydmVyQ29udGV4dFBhdGggKyBgL2FwaS9kb2t1bWVudHkvdjEvb2JhbGt5L3NhYmxvbmEvJHtzYWJsb25hS29kfS9zdHJlYW1gO1xuICAgICAgICBjb25zdCBwYXJhbXMgPSB7IG9kZXNpbGF0ZWwsIG1ldGEsIHBhZ2VPZmZzZXQgfTtcbiAgICAgICAgcmV0dXJuIGdlbmVyYXRlVXJsKHVyaSwgcGFyYW1zLCB0cnVlKTtcbiAgICB9XG5cbiAgICAvKipcbiAgICAgKiBOYWpkZSBrb25rcsOpdG7DrSDFoWFibG9udSBkbGUga8OzZHUuXG4gICAgICpcbiAgICAgKiBAcGFyYW0gc2FibG9uYUtvZCBrw7NkIMWhYWJsb255XG4gICAgICogQHJldHVybiDFoWFibG9uYVxuICAgICAqL1xuICAgIHN0YXRpYyBnZXRPYmFsa2FTYWJsb25hQnlLb2Qoc2FibG9uYUtvZCkge1xuICAgICAgICBjb25zdCB1cmkgPSBzZXJ2ZXJDb250ZXh0UGF0aCArIGAvYXBpL2Rva3VtZW50eS92MS9vYmFsa3kvc2FibG9uYS8ke3NhYmxvbmFLb2R9YDtcbiAgICAgICAgY29uc3QgaGVhZGVycyA9IHVuZGVmaW5lZDtcbiAgICAgICAgY29uc3QgcGFyYW1zID0geyAgfTtcbiAgICAgICAgIFxuICAgICAgICByZXR1cm4gRXJyb3JBcGkucmVzcG9uc2VSZXNvbHZlcihKc29uRmV0Y2guZ2V0KHVyaSwgcGFyYW1zLCBoZWFkZXJzKSk7XG4gICAgfVxuXG4gICAgLyoqXG4gICAgICogVnl0aXNrbmUgdGVzdG92YWPDrSDFoXTDrXRlayBzIHVtxJtsw71taSBkYXR5LlxuICAgICAqXG4gICAgICogQHBhcmFtIHNhYmxvbmFLb2Qga8OzZCDFoWFibG9ueVxuICAgICAqIEBwYXJhbSBwYWdlT2Zmc2V0IHBvc3VuIHRpc2t1XG4gICAgICogQHJldHVybiB0ZXN0b3ZhY8OtIMWhdMOtdGVrXG4gICAgICovXG4gICAgc3RhdGljIHprdXNlYm5pVGlzayhzYWJsb25hS29kLCBwYWdlT2Zmc2V0KSA6IFN0cmluZyB7XG4gICAgICAgIGNvbnN0IHVyaSA9IHNlcnZlckNvbnRleHRQYXRoICsgYC9hcGkvZG9rdW1lbnR5L3YxL29iYWxreS90ZXN0b3ZhY2kvc2FibG9uYS8ke3NhYmxvbmFLb2R9L3N0cmVhbWA7XG4gICAgICAgIGNvbnN0IHBhcmFtcyA9IHsgcGFnZU9mZnNldCB9O1xuICAgICAgICByZXR1cm4gZ2VuZXJhdGVVcmwodXJpLCBwYXJhbXMsIHRydWUpO1xuICAgIH1cblxufVxuIl19